import { useMemo } from "react";
import { loginProviderFromAuth0Id } from "@common/helpers/auth0-login-provider";
import type { Auth0LoginProvider } from "@common/helpers/auth0-login-provider";
import { peekAccessToken } from "@lib/auth0";

function readJwtSub(token: string): string | null {
    const payload = token.split(".")[1];
    if (!payload) {
        return null;
    }
    try {
        const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
        const parsed: { sub?: string } = JSON.parse(atob(normalized));
        return typeof parsed.sub === "string" ? parsed.sub : null;
    } catch {
        return null;
    }
}

export function loginProviderFromAccessToken(
    token: string | null,
): Auth0LoginProvider {
    if (!token) {
        return "unknown";
    }
    if (token.includes("@")) {
        return "email";
    }
    const auth0Id = readJwtSub(token);
    if (!auth0Id) {
        return "unknown";
    }
    return loginProviderFromAuth0Id(auth0Id);
}

export function useCurrentLoginProvider(): Auth0LoginProvider {
    return useMemo(() => loginProviderFromAccessToken(peekAccessToken()), []);
}
